import { InputSwitch } from 'primereact/inputswitch';

/**
 * The shared "Show core" switch for every project-scoped list's toolbar.
 *
 * Off = the project's own rows only; on = also the core/seed rows (appId=null).
 * One component so the label, size and behaviour stay identical across all
 * masters (Prompts, AI masters, Notification, Personnel, …). Pair it with the
 * `include_global` query param the list endpoint reads.
 */
export function ShowCoreToggle({
  checked,
  onChange,
  testId,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  testId?: string;
}) {
  return (
    <label className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-300">
      <InputSwitch checked={checked} onChange={(e: any) => onChange(!!e.value)} data-testid={testId} />
      Show core
    </label>
  );
}

export default ShowCoreToggle;
